import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import '../../../atoms/buttons/generic-button2.0/index.js';
import css_248z from './cards-gallery-plus-card.scss.js';
import { CardsGalleryPlusCardBackground, CardsGalleryPlusTemplateType, CardsGalleryPlusTitleColor, CardsGalleryPlusButtonType } from '../enums.js';

const DARK_BACKGROUNDS = [
    CardsGalleryPlusCardBackground.NIGHT,
    CardsGalleryPlusCardBackground.BURGUNDY,
    CardsGalleryPlusCardBackground.PURPLE,
];
const LIGHT_BACKGROUNDS = [
    CardsGalleryPlusCardBackground.GREY,
    CardsGalleryPlusCardBackground.WHITE,
];
let CardsGalleryPlusCard = class CardsGalleryPlusCard extends s {
    constructor() {
        super(...arguments);
        this.templateType = CardsGalleryPlusTemplateType.CLASSIC;
        this.date = '';
        this.category = '';
        this.labels = '';
        this.textcardAlign = '';
        this.cardheadlinesize = '';
        this.title = '';
        this.text = '';
        this.ctaLabel = 'Link text';
        this.ctaHref = '#';
        this.imgSrc = '';
        this.imgAlt = '';
        this.imgDecorative = '';
        this.titleColor = CardsGalleryPlusTitleColor.BLACK;
        this.cardBackground = CardsGalleryPlusCardBackground.WHITE;
        this.ctaType = CardsGalleryPlusButtonType.TERTIARY;
        this.rtl = false;
        // Unique ID passed from the backend (e.g. "card-363525-0").
        // Used to wire aria-labelledby between the CTA link and the card title.
        this.cardId = '';
    }
    // ─── Private renderers ────────────────────────────────────────────────────
    _renderCardMeta() {
        if (this.templateType === CardsGalleryPlusTemplateType.FLOATING) {
            return w;
        }
        // Resolve the list of labels: prefer the `labels` JSON array, fall back to single `category`.
        let labelList = [];
        if (this.labels) {
            try {
                const parsed = JSON.parse(this.labels);
                labelList = Array.isArray(parsed) ? parsed : [];
            }
            catch (_a) {
                labelList = [];
            }
        }
        if (labelList.length === 0 && this.category) {
            labelList = [this.category];
        }
        const categoryItem = labelList.length > 0
            ? $ `<ul class="cgp-card__categories" aria-label="Categories">${labelList.map(label => $ `<li class="cgp-card__category">${label}</li>`)}</ul>`
            : w;
        return $ `<time class="cgp-card__date" datetime="${this.date}">${this.date}</time> ${categoryItem}`;
    }
    _renderCardImage() {
        if (this.imgSrc) {
            return $ `<img class="cgp-card__image" src="${this.imgSrc}" alt="${this.imgDecorative === 'decorative' ? '' : this.imgAlt}" loading="lazy">`;
        }
        return $ `<div class="cgp-card__image cgp-card__image--placeholder" aria-hidden="true"></div>`;
    }
    render() {
        return $ `<article class="cgp-card cgp-card--${this.templateType} cgp-card--bg-${this.cardBackground}"><div class="cgp-card__image-wrapper">${this._renderCardImage()}</div><div class="cgp-card__body">${this._renderCardMeta()}<h3 id="${l(this.cardId ? `${this.cardId}-title` : undefined)}" class="cgp-card__title ${LIGHT_BACKGROUNDS.includes(this.cardBackground) ? `cgp-card__title--${this.titleColor}` : ''}">${this.title}</h3><p class="cgp-card__text">${this.text}</p><generic-button-updated type="${this.ctaType}" color="${this.cardBackground === CardsGalleryPlusCardBackground.BURGUNDY ? 'burgundy' : 'purple'}" styleType="${DARK_BACKGROUNDS.includes(this.cardBackground) ? 'dark' : 'light'}" label="${this.ctaLabel}" href="${this.ctaHref}" id="${l(this.cardId ? `${this.cardId}-cta` : undefined)}" .ariaList="${this.cardId ? { 'aria-labelledby': `${this.cardId}-cta ${this.cardId}-title` } : {}}"></generic-button-updated></div></article>`;
    }
};
CardsGalleryPlusCard.styles = css_248z;
__decorate([
    e({ type: String, reflect: true })
], CardsGalleryPlusCard.prototype, "templateType", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "date", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "category", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "labels", void 0);
__decorate([
    e({ type: String, reflect: true })
], CardsGalleryPlusCard.prototype, "textcardAlign", void 0);
__decorate([
    e({ type: String, reflect: true })
], CardsGalleryPlusCard.prototype, "cardheadlinesize", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "title", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "text", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "ctaLabel", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "ctaHref", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "imgSrc", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "imgAlt", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "imgDecorative", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "titleColor", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "cardBackground", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "ctaType", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], CardsGalleryPlusCard.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlusCard.prototype, "cardId", void 0);
CardsGalleryPlusCard = __decorate([
    n('cards-gallery-plus-card')
], CardsGalleryPlusCard);

export { CardsGalleryPlusCard };
